import { render, staticRenderFns } from "./SetStaticRoutes.vue?vue&type=template&id=faca63ac"
import script from "./SetStaticRoutes.vue?vue&type=script&lang=js"
export * from "./SetStaticRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports